/**
 * Validation Utilities - Central Export
 *
 * Centralized exports for validation utilities and validated fetch functions.
 */

// Validation utilities
export {
  validateItem,
  validateArray,
  validateApiResponse,
  validateApiArrayResponse,
  unwrapValidation,
  unwrapValidationOr,
  unwrapValidationOrNull,
  type ValidationResult,
  type ValidationSuccess,
  type ValidationError,
  type ValidationOptions,
} from "./api-validator";

// Validated fetch functions
export {
  fetchValidated,
  fetchValidatedArray,
  postValidated,
  postValidatedArray,
  putValidated,
  deleteValidated,
  type ValidatedFetchOptions,
} from "../api/validated-fetch";
